<template>
  <section class="page-header" :style="{ height: `${headerH}px` }">
    <div class="header-main">
      <div class="logo">
        <img src="@/assets/logo.svg" class="main" />
        <img src="@/assets/beta.svg" class="beta" />
      </div>
      <div class="header-navs">
        <div class="item" :class="{ selected: tab?.id == item?.id, disabled: item?.disabled }" v-for="(item, index) in tabs" :key="index" @click.stop="selectTab(item)">
          <span>{{item.label}}
            <el-icon v-if="item?.children?.length > 0">
              <ArrowUp v-if="showTab?.id == item?.id" />
              <ArrowDown v-if="showTab?.id != item?.id" />
            </el-icon>
          </span>
          <div class="cnavs" v-if="item?.children?.length > 0 && showTab?.id == item?.id"
            :style="{ width: `${(item.limitfree * 52 || item.pluslimit * 68 || 0) + item?.children.length * 66}px` }"
          >
            <div class="item" :class="{
              selected: childTab?.id == citem?.id,
              disabled: citem?.disabled,
              limitfree: item.limitfree && citem.limitfree,
              pluslimit: item.pluslimit && citem.pluslimit }
            " v-for="(citem, cindex) in item?.children" :key="cindex" @click.stop="selectChildTab(citem)">
              <span>{{citem.label}}</span>
              <img class="limitfree-img" src="@/assets/images/limitfree.svg" />
              <img class="pluslimit-img" src="@/assets/images/pluslimit.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dropdown>
      <img style="width: 32px; height: 32px; border-radius: 100%;" src="./images/useravatar.png" />
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item><el-link type="default" @click="logoutHandle">退出登录</el-link></el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </section>
</template>

<script setup>
  import {onMounted, ref, watch} from "vue";
  import { useRouter, useRoute } from 'vue-router';
  import * as Utils from '@/assets/utils'
  import * as Request from '@/assets/request'
  import { ArrowDown, ArrowUp, User } from '@element-plus/icons-vue'
  import { useProductValid } from '@/hooks/useProductValid'

  const router = useRouter();
  const route = useRoute();
  const { tenantInfo, getTenantInfo } = useProductValid()

  const headerH = ref(window.sessionStorage.getItem('ghhh') || 70);
  const setHeaderH = (h) => {
    window.sessionStorage.setItem('ghhh', h);
    headerH.value = h
  }

  const ctrlTabs = ref([]);
  const getCtrlTabs = async () => {
    const result = await Request.post({
      url: '/40002/rms/menu/getMenuByUserId',
      data: {
        appId:9,
        enableAppFilter: true
      }
    });
    if(result?.code != 200) return;
    // 测试极羽532675516575195136, 惠禾865689422270763008
    if (['532675516575195136', '865689422270763008'].includes(tenantInfo.value.tenantId)) {
      const menuList = result?.data?.menuList || [];
      // 判断是否有hand_custom_task显示定制化任务
      if(menuList.some(item => item.childNode.some(item => item.menuKey == 'hand_custom_task'))) {
        tabs.value[1].children.push({
          label: '定制化任务', id: 52, path: 'custom-task'
        })
      }
      // 判断是否有hand_custom_logs显示定制化日志
      if(menuList.some(item => item.childNode.some(item => item.menuKey == 'hand_custom_logs'))) {
        tabs.value[2].children.push({
          label: '定制化日志', id: 33, path: 'custom-logs'
        })
      }
    }
    init()
  }

  onMounted(() => {
    getTenantInfo().then(() => {
      getCtrlTabs()
    })
  });

  const tabs = ref([
    { label: '调度中心', id: 1, path: 'dispatch' },
    { label: '任务中心', id: 5,
      children: [
        { label: '通用任务', id: 51, path: 'task' },
      ]
    },
    {
      label: '日志中心', id: 3,
      children: [
        { label: '应用日志', id: 31, path: 'apps-logs' },
        { label: '机器日志', id: 32, path: 'mathines-logs' },
      ]
    },
    {
      label: '数据中心', id: 2, limitfree: 0, pluslimit: 1,
      children: [
        { label: '使用数据', id: 21, path: 'stat-main' },
        { label: '运价数据库', id: 23, path: 'stat-rate' },
        { label: '船司数据', id: 22, path: 'stat-carrier', limitfree: false, pluslimit: true }
      ]
    },
    {
      label: '通用配置', id: 4,
      children: [
        { label: '通用信息', id: 41, path: 'normal-setting' },
        { label: '模板配置', id: 42, path: 'tpl-setting' },
      ]
    }
  ])
  const showTab = ref(null)
  const tab = ref(null)
  const childTab = ref(null)
  const selectTab = (item, fromtab = true) => {
    if(item?.disabled) return;

    if(item?.children?.length > 0) {
      showTab.value = item?.id == showTab.value?.id ? null : item;
    }else{
      tab.value = item;
      showTab.value = null;
      childTab.value = null;
      if(fromtab) {
        setTimeout(() => {
          router.push(item?.path);
        },200);
      }
    }
  }
  const selectChildTab = (item, fromtab = true) => {
    if(!item) return;
    if(item?.disabled) return;

    tab.value = showTab.value;
    childTab.value = item;
    if(fromtab) {
      router.push(item?.path)
    }
  }

  watch(() => [ tab.value, showTab.value ], () => {
    console.log('showTab---', showTab)
    if(showTab.value) {
      setHeaderH(82)
    }else{
      setHeaderH(70)
    }
  })

  const init = () => {
    const pathname = route.name

    if(pathname) {
      let tabItem = null
      let childTabItem = null
      tabs.value.map((tab, tabIndex) => {
        if(tab?.children?.length > 0) {
          tab.children.map((childTab, childTabIndex) => {
            if(pathname == childTab.path) {
              tabItem = tab;
              childTabItem = childTab
            }
          })
        }else{
          if(pathname == tab.path) {
            tabItem = tab;
          }
        }
      })
      selectTab(tabItem, false);
      selectChildTab(childTabItem, false);
    }else{
      selectTab(tabs.value[0], false);
    }
  }
  watch(() => route.name, () => {
    init()
  })

  const userInfo = ref(null)
  const getUserInfo = () => {
    userInfo.value = Utils.user.getInfo()
  }
  onMounted(() => {
    getUserInfo()
  })

  const logoutHandle = () => {
    Utils.user.logout()
  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
